import { useState, useRef, useEffect } from "react";
import { Search } from "lucide-react";

export function LibraryAutocomplete({ value, onChange, items, placeholder, className }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => { setQuery(value || ""); }, [value]);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = items.filter(i => i.name.toLowerCase().includes(query.toLowerCase())).slice(0, 12);

  return (
    <div ref={ref} className="relative">
      <div className="relative">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[hsl(var(--muted-foreground))] pointer-events-none" />
        <input
          type="text"
          value={query}
          onChange={(e) => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          className={`w-full pl-8 pr-3 py-2 rounded-md border text-sm bg-[hsl(var(--secondary))] border-[hsl(var(--border))] text-[hsl(var(--foreground))] placeholder:text-[hsl(var(--muted-foreground))] focus:outline-none focus:ring-1 focus:ring-[hsl(var(--ring))] ${className || ""}`}
          data-testid={`autocomplete-${(placeholder || 'field').replace(/[.\s]+/g, '-').replace(/^-|-$/g, '').toLowerCase()}`}
        />
      </div>
      {open && filtered.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-48 overflow-y-auto rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--card))] shadow-lg">
          {filtered.map(item => (
            <button
              key={item.id || item.name}
              type="button"
              onClick={() => { onChange(item.name); setQuery(item.name); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[hsl(var(--accent))] transition-colors flex items-center gap-2"
            >
              {item.image_url && (
                <img src={`${process.env.REACT_APP_BACKEND_URL}${item.image_url}`} alt="" className="w-6 h-6 rounded object-cover shrink-0" />
              )}
              <span>{item.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
